import { Link } from 'react-router-dom';

export default function Footer() {
  const footerLinks = {
    content: [
      { label: '影视', to: '/category/yingshi' },
      { label: '综艺', to: '/category/zongyi' },
      { label: '动漫', to: '/category/dongman' },
      { label: '短视频', to: '/category/duanshipin' },
      { label: '纪录片', to: '/category/jilupian' },
      { label: '体育', to: '/category/tiyu' },
    ],
    about: [
      { label: '关于我们', to: '/about' },
      { label: '联系方式', to: '/about#contact' },
      { label: '品牌故事', to: '/about#brand' },
      { label: '用户口碑', to: '/about#reputation' },
    ],
    help: [
      { label: '使用帮助', to: '/about' },
      { label: '意见反馈', to: '/about#contact' },
      { label: '内容合作', to: '/about#contact' },
      { label: '版权声明', to: '/about' },
    ],
  };

  return (
    <footer className="bg-background-900 text-foreground-200">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          <div>
            <Link to="/" className="flex items-center gap-2 mb-4 whitespace-nowrap">
              <div className="w-8 h-8 flex items-center justify-center">
                <i className="ri-play-circle-fill text-2xl text-primary-500"></i>
              </div>
              <span className="text-lg font-heading font-bold text-foreground-50">
                久久视频
              </span>
            </Link>
            <p className="text-sm text-foreground-400 leading-relaxed">
              海量高清视频免费在线观看，涵盖影视、综艺、动漫、短视频等多种类型，流畅播放无卡顿，随时随地畅享精彩内容体验。
            </p>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-50 mb-4">
              <a href="#content-links" className="hover:text-primary-400 transition-colors">内容分类</a>
            </h4>
            <ul className="space-y-2.5">
              {footerLinks.content.map((link) => (
                <li key={link.to}>
                  <Link
                    to={link.to}
                    className="text-sm text-foreground-400 hover:text-foreground-200 transition-colors cursor-pointer whitespace-nowrap"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-50 mb-4">
              <a href="#about-links" className="hover:text-primary-400 transition-colors">关于久久</a>
            </h4>
            <ul className="space-y-2.5">
              {footerLinks.about.map((link) => (
                <li key={link.to}>
                  <Link
                    to={link.to}
                    className="text-sm text-foreground-400 hover:text-foreground-200 transition-colors cursor-pointer whitespace-nowrap"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-50 mb-4">
              <a href="#help-links" className="hover:text-primary-400 transition-colors">帮助中心</a>
            </h4>
            <ul className="space-y-2.5">
              {footerLinks.help.map((link) => (
                <li key={link.to}>
                  <Link
                    to={link.to}
                    className="text-sm text-foreground-400 hover:text-foreground-200 transition-colors cursor-pointer whitespace-nowrap"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="mt-12 pt-8 border-t border-background-700/50 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-foreground-500">
            &copy; {new Date().getFullYear()} 久久视频 jiujiu-video.com 版权所有
          </p>
          <div className="flex items-center gap-4">
            <a href="#" className="text-xs text-foreground-500 hover:text-foreground-300 transition-colors whitespace-nowrap" rel="nofollow">隐私政策</a>
            <a href="#" className="text-xs text-foreground-500 hover:text-foreground-300 transition-colors whitespace-nowrap" rel="nofollow">服务条款</a>
            <a href="#" className="text-xs text-foreground-500 hover:text-foreground-300 transition-colors whitespace-nowrap" rel="nofollow">版权声明</a>
          </div>
        </div>
      </div>
    </footer>
  );
}